import { useEffect, useRef } from 'react';
import { post } from '../../../services/api';

interface UseEventScheduleSyncResult {
    status: 'sync_initiated';
    user_email: string;
}

interface UseEventScheduleSyncOptions {
    enabled?: boolean;
}

export const useEventScheduleSync = (
    { enabled = true }: UseEventScheduleSyncOptions = {},
): void => {
    const hasSynced = useRef(false);

    useEffect(() => {
        if (!enabled || hasSynced.current) return;

        hasSynced.current = true;

        post<UseEventScheduleSyncResult>('/api/v1/meeting-availability/trigger-sync', null).catch((error) => {
            console.warn('Calendar sync trigger failed:', error);
        });
    }, [enabled]);
};